import { Injectable } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api/api.service';
import { Observable } from 'rxjs';
import { IPagination } from '../../../../../shared/services/api/interface/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class FormTabService {
  constructor(private readonly apiService: ApiService) {}

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(
      `form-tab/form-tab-filter-list`,
      { event: event, filter: filter }
    );
  }

  getList() {
    return this.apiService.get<any[]>('form-tab');
  }

  getById(id: string) {
    return this.apiService.get(`form-tab/${id}`);
  }

  create(data: any) {
    return this.apiService.post('form-tab/create', data);
  }

  update(data: any) {
    return this.apiService.patch('form-tab/update', data);
  }

  delete(id: number) {
    return this.apiService.delete(`form-tab/delete/${id}`);
  }

  getAllTabItemsByFormIdAndFormMenuId(filter: {
    formId: number;
    formMenuId: number;
    caseId?: number;
    type: FormTabItemsGetTypeEnum;
  }) {
    return this.apiService.post<any[]>(
      'form-tab/get-all-tab-by-form-id-and-from-menu-id',
      filter
    );
  }

  saveQuestions(
    answers: {
      formId: number;
      formMenuId: number;
      formTabId: number;
      formTabItemId: number;
      description: string | null;
      caseId: number;
      answerLabel: string | null;
      answerValue: string | null;
    }[]
  ) {
    return this.apiService.post<{message:string,status:number,success:boolean}>('form-tab-answers/create', answers);
  }
}

export enum FormTabItemsGetTypeEnum {
  QUESTION = 'QUESTION',
  QUESTION_ANSWER = 'QUESTION_ANSWER',
}
